export default [
  {
    path: '/agent',
    name: 'Agent',
    meta: { title: '代理商后台', requireAuth: true },
    component: () => import('@/views/agent/agent.vue'),
    children: [
      {
        path: '',
        redirect: '/agent/index'
      },
      {
        path: 'index',
        name: 'AgentIndex',
        component: () => import('@/views/agent/index/index.vue'),
        meta: { title: '代理商后台', requireAgent: true }
      },
      {
        path: 'poster',
        name: 'AgentPoster',
        component: () => import('@/views/agent/poster.vue'),
        meta: { title: '成为代理商', requireAgent: false }
      },
      {
        path: 'cashout/cashout',
        name: 'AgentCashout',
        component: () => import('@/views/agent/cashout/cashout.vue'),
        meta: { title: '佣金提现', requireAgent: true }
      },
      {
        path: 'cashout/list',
        name: 'AgentCashoutList',
        component: () => import('@/views/agent/cashout/list.vue'),
        meta: { title: '提现记录', requireAgent: true }
      },
      {
        path: 'commission/list',
        name: 'AgentCommission',
        component: () => import('@/views/agent/commission/list.vue'),
        meta: { title: '佣金明细', requireAgent: true }
      },
      {
        path: 'material/poster',
        name: 'AgentMaterialPoster',
        component: () => import('@/views/agent/material/poster.vue'),
        meta: { title: '推广海报', requireAgent: true }
      }
    ]
  }
]
